export const automationProcessContent = {
    "how-to-build-auto-tickets-create": {
      title: "Ticket create",
      content: `
          <ul class="steps-list">
          <li>Log in to your anydone account.</li>
          <li>Click on the <strong>Automation Tools</strong> icon from the left side of your dashboard.</li>
          <li>Select the <strong>Process</strong> option.</li>
          <li>Click the <strong>+</strong> button from the bottom-right corner.</li>
          <li>Enter a <strong>name</strong> and <strong>description</strong> for the process.</li>
          <li>Under <strong>Type</strong>, search for and select <strong>Ticket Create.</strong></li>
          <li>Configure the following:
            <ul>
            <li><strong>Project:</strong> Select the project where the ticket should be created.</li>
            <li><strong>Folder:</strong> Choose the folder where tickets will be stored.</li>
            </ul>
          </li>
          <li><strong>Map the output</strong> from the Output Sample.</li>
          <li>Then, click the <strong>Create</strong> button.</li>
          </ul>
  
        <video-component src="https://edge-a.anydone.com/treeleaf/d243b495-b96c-4351-839c-6277036c1ea0.mp4"></video-component>

          <h3 class="headingThree">Additional Information:</h3>
          <p>In the video, we’ve selected the ticket URL as an example. However, you can choose any output based on your preference. Below, we’ve provided descriptions of each output sample to help you select the one that best fits your needs.</p>

          <h3 class="headingThree">Sample Output:</h3>
          <p>Select and add the necessary ticket details according to your needs, which will be automatically included in the created ticket based on predefined conditions.</p>
          <ul>
          <li><strong>ticketId:</strong> A unique identifier for the ticket.</li>
          <li><strong>title:</strong> The title of the ticket.</li>
          <li><strong>description:</strong> Additional details or context about the ticket.</li>
          <li><strong>customer:</strong> Information about the customer.<br>
          <ul>
          <li><strong>customerId:</strong> A unique identifier for the customer.</li>
          <li><strong>fullName:</strong> The full name of the customer.</li>
          <li><strong>email:</strong>  The customer’s email address.</li>
          <li><strong>profilePic:</strong> The customer's profile picture.</li>
          </ul>
          </li>
          <li><strong>createdBy:</strong> Details of the account that created the ticket <br>
          <ul>
          <li><strong>accountId:</strong> A unique identifier for the creator's account.</li>
          <li><strong>accountType:</strong> The type of account (e.g., user, admin).</li>
          <li><strong>profilePic:</strong>  The profile picture URL of the creator.</li>
          </ul>
          </li>
          <li><strong>shareLink:</strong>  A URL to share the ticket.</li>
          </ul>
          `,
    },
    "how-to-create-text-to-speech":{
        title:"Text to Speech",
        content:`   
        <p>There are two approaches to building AI Agents with Speech to Text in anydone:</p>
        <ol type="a">
        <li>
            <strong>Using the Anydone Model </strong><br>
            This option requires no additional configuration or setup. Simply select the Anydone Model while creating the Text to Speech Process, and you can seamlessly build your AI Agents.
        </li>
        <li>
            <strong>Integrating Third-Party Models:</strong> <br>
          If you prefer to use a third-party model, first you need to integrate their Text to Speech models then you can start building AI Agents tailored to your needs.
        </li>
        </ol>

        <h3 class="headingThree">Creating Text to Speech Model</h3>
        <ul class="steps-list">
            <li>Log in to your Anydone account.</li>
            <li>Click on the <strong>Automation Tools</strong> icon on the left side of your dashboard.</li>
            <li>Select the <strong>Process</strong> option.</li>
            <li>Click the <strong>+</strong> button from the bottom-right corner.</li>
            <li>Enter a <strong>name</strong> and <strong>description</strong> for the process.</li>
            <li>Under <strong>Type</strong>, search and select the <strong>Text to Speech</strong> option.</li>
            <li>Under <strong>Model</strong>, choose your preferred model (Select between the Anydone Model or a third-party model).</li>
            <li>Define the <strong>Input</strong> and <strong>Output</strong> settings.</li>
            <li>Finally, click the <strong>Create</strong> button.</li>
        </ul>
        <video-component src="https://edge-a.anydone.com/treeleaf/5a1c864c-b1c1-4358-898e-4bed0b08548b.mp4"></video-component>

        <h3 class="headingTwo underline-text">Configuring the Text to Speech Process:</h3>
        <h3 class="headingThree text-blue">Input Components:</h3>
        <ul class="no-listing">
        <li><i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Input Name:</span> Includes Text, Text Source Language, and Audio Destination Language, these names are fixed and cannot be edited.</li>
        <li><i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Mapping Name:</span> Editable for all inputs.</li>
        <li><i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Mapping Description:</span> Optional; users can provide descriptions for the mapping.</li>
        <li><i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Input Type:</span> Choose between Dynamic or Static:
        <ul class="no-listing">
            <li><span class="underline-text">If input Data Type is Static:</span> Define inputs within the Process, and then it will generate output based on the mapped input, once mapped and triggered you cannot change it later.
            <ul>
            <li><span>Text:</span> Define the text to be converted to speech.</li>
            <li><span>Text Source Language:</span> Specify the source language of the text.</li>
            <li><span>Audio Destination Language::</span> Specify the language for audio output.</li>
            </ul>
            </li>
            <li><span class="underline-text">If input Data Type is Dynamic:</span> You need to leave its field as it is, you don't have to define anything in the Process.
            </li>
        </ul>
        </li>
        </ul>
        
        <h3 class="headingThree text-blue">Output Components:</h3>
        <p>
        You need to select the outputs from the output sample, then output fields will be mapped automatically upon selection.
        </p>
        <p><i class="fa-solid fa-arrow-right-long"></i> <strong>Editable Fields</strong></p>
        <ul>
        <li>Mapping Name and Mapping Description can be edited.</li>
        </ul>
        <p>
        <strong>Note:</strong> Once you mapped the outputs from the Output sample, it is recommended not to make any type of changes to the <strong>Mapping Type </strong> and <strong>Map To</strong> fields.
        </p>

        <h3 class="headingThree text-blue">Output Sample:</h3>
        <p><i class="fa-solid fa-arrow-right-long"></i> audioFileUrl: "public link to synthesized audio"    -  A public link will be generated that includes the URL of an audio file.</p>

        <h3 class="headingThree">Building a Text to Speech AI Agent in anydone AI Studio</h3>
        <p>The Text to Speech AI Agent in anydone Studio is designed to convert user-submitted text into spoken audio output. This can enhance accessibility, enable voice-based responses, and support voice assistants or audio-driven interfaces. </p>

        <span class="underline-text">Input Block</span> <br>
        <p>We begin by using an Input Block where the input type is set to "Text". This allows the AI Agent to receive any English text from the user for processing.</p>

        <span class="underline-text">Text to Speech Process Block</span> <br>
        <p>Next, we add the Text to Speech Process block from the AI Models section. This block takes the input text and generates an audio version of it, then connected with the variable $input_1.query
        Defined source Language: English,  Destination Language: Dutch.  The model processes the text input in English and generates an audio file Dutch as a response. 
        </p>

        <span class="underline-text">Send Reply Block</span> <br>
        <p>To deliver the audio output back to the user, we use the Send Reply Block, connected to the process block using the variable $text_to_speech_process_1.audioFileUrl this variable provides the URL to the generated audio file. It allows the user to stream or download the speech output. </p>

        <span class="underline-text">Log Blocks (Optional)</span> <br>
        <p>We have also added Log blocks after each key action — both for success and error cases. These logs are useful for tracking the agent's behavior, debugging any failures, and monitoring successful operations. </p>
        `
    },
    "how-to-create-speech-to-text":{
        title:"Speech to Text",
        content:`
        <p>There are two approaches to building AI Agents with Speech to Text in anydone:</p>
        <ol type="a">
        <li>
            <strong>Using the Anydone Model </strong><br>
            This option requires no additional setup or configuration. Simply select the <strong>Anydone Model</strong> while creating the Speech to Text Process, and you can effortlessly build your AI Agents.
        </li>
        <li>
            <strong>Integrating Third-Party Models:</strong> <br>
            If you prefer to use a third-party Speech to Text model, you’ll need to <span class="text-blue">integrate it first.<span> Once integrated, you can start building AI Agents customized to meet your requirements.
        </li>
        </ol>
        <ul class="steps-list">
            <li>Log in to your Anydone account.</li>
            <li>Click on the <strong>Automation Tools</strong> icon on the left side of your dashboard.</li>
            <li>Select the <strong>Process</strong> option.</li>
            <li>Click the <strong>+</strong> button from the bottom-right corner.</li>
            <li>Enter a <strong>name</strong> and <strong>description</strong> for the process.</li>
            <li>Under <strong>Type</strong>, search and select the <strong>Speech to Text</strong> option.</li>
            <li>Under <strong>Model</strong>, choose your preferred model (Select between the Anydone Model or a third-party model).</li>
            <li>Define the <strong>Input</strong> and <strong>Output</strong> settings.</li>
            <li>Finally, click the <strong>Create</strong> button.</li>
        </ul>

        <h3 class="headingTwo underline-text">Configuring the Speech to Text Process:</h3>
        <h3 class="headingThree text-blue">Input Components:</h3>
        <ul class="no-listing">
        <li><i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Input Name:</span> Includes audio source, audio source language, and text destination language, these names are fixed and cannot be edited.</li>
        <li><i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Mapping Name:</span> The Default mapping name is editable for all inputs.</li>
        <li><i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Mapping Description:</span> Optional; users can provide descriptions for the mapping.</li>
        <li><i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Input Type:</span> Choose between Dynamic or Static:
        <ul class="no-listing">
            <li><span class="underline-text">If input Data Type is Static:</span> Define inputs within the Process, and then it will generate output based on the mapped input, once mapped and triggered you cannot change it later.
            <ul>
            <li><span>Audio Source:</span> Upload the audio file you want to transcribe.</li>
            <li><span>Audio Source Language:</span> Specify the language of the audio file.</li>
            <li><span>Text Destination Language:</span> Specify the language for the transcribed text output.</li>
            </ul>
            </li>
            <li><span class="underline-text">If input Data Type is Dynamic:</span> You need to leave its field as it is, you don't have to define anything in the Process.
            </li>
        </ul>
        </li>
        </ul>
        
        <h3 class="headingThree text-blue">Output Components:</h3>
        <p>
        You need to select the outputs from the output sample, then output fields will be mapped automatically upon selection.
        </p>
        <p><i class="fa-solid fa-arrow-right-long"></i> <strong>Editable Fields</strong></p>
        <ul>
        <li>Mapping Name and Mapping Description can be edited.</li>
        </ul>
        <p>
        <strong>Note:</strong> Once you mapped the outputs from the Output sample, it is recommended not to make any type of changes to the <strong>Mapping Type </strong> and <strong>Map To</strong> fields.
        </p>

        <h3 class="headingThree text-blue">Output Sample:</h3>
        <p><i class="fa-solid fa-arrow-right-long"></i> transcript: "transcription from audio"   -  Convert audio words into text</p>

        `
    },
    "how-to-create-ocr":{
        title:"OCR (Optical Character Recognition)",
        content:`
        <ul class="steps-list">
          <li>Log in to your anydone account.</li>
          <li>Click on the <strong>Automation Tools</strong> icon from the left side of your dashboard.</li>
          <li>Select the <strong>Process</strong> option.</li>
          <li>Click the <strong>+</strong> button from the bottom-right corner.</li>
          <li>Enter a <strong>name</strong> and <strong>description</strong> for the process.</li>
          <li>Under <strong>Type</strong>, search for and select <strong>OCR option .</strong></li>
          <li>Under <strong>Model</strong> >> <strong>Anydone Model</strong></li>
          <li><strong>Define input</strong> and <strong>Output</strong> settings.</li>
          <li>Finally, click the <strong>Create</strong> button.</li>
          </ul>

        <h3 class="headingTwo underline-text">Configuring the OCR Process:</h3>
        <h3 class="headingThree text-blue">Input Components:</h3>
        <ul class="no-listing">
        <li><i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Input Name:</span> Include image-source is fixed and cannot be edited.</li>
        <li><i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Mapping Name:</span> The default mapping name is editable.</li>
        <li><i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Mapping Description:</span> Optional; users can provide a description for the mapping if needed.</li>
        <li><i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Input Type:</span> Choose between Dynamic or Static:
        <ul class="no-listing">
            <li><span class="underline-text">If input Data Type is Static:</span> Define inputs within the Process, and then it will generate output based on the mapped input, once mapped and triggered you cannot change it later.
            <ul>
            <li>Choose from URL, File, or Image:</li>
            <li>Upload an image or file, or provide a URL.</li>
            </ul>
            </li>
            <li><span class="underline-text">If input Data Type is Dynamic:</span> You need to leave its field as it is, you don't have to define anything in the Process.
            </li>
        </ul>
        </li>
        </ul>
        
        <h3 class="headingThree text-blue">Output Components:</h3>
        <p>
        You need to select the outputs from the output sample, then output fields will be mapped automatically upon selection.
        </p>
        <p><i class="fa-solid fa-arrow-right-long"></i> <strong>Editable Fields</strong></p>
        <ul>
        <li>Mapping Name and Mapping Description can be edited.</li>
        </ul>
        <p>
        <strong>Note:</strong> Once you mapped the outputs from the Output sample, it is recommended not to make any type of changes to the <strong>Mapping Type </strong> and <strong>Map To</strong> fields.
        </p>

        <h3 class="headingThree text-blue">Output Sample:</h3>
        <ul>
        <li><strong>lensResult:</strong> Represents the overall result of the OCR (Optical Character Recognition).</li>
        <li><strong>ocrResult:</strong> Contains detailed information extracted during the OCR process.</li>
        <li><strong>rawText: </strong>Displays the raw text extracted from the image.</li>
        <li><strong>extractedValues:</strong> A list of extracted values from the OCR process, providing details for each identified element.</li>
        <li><strong>box:</strong> Specifies the bounding box coordinates (left, top, bottom, right) for the detected text in the image.</li>
        <li><strong>value:</strong> Shows the actual extracted content.</li>
        <li><strong>rowLine:</strong> Indicates the row position of the text element in the structured layout.</li>
        <li><strong>columnLine:</strong> Indicates the column position of the text element in the structured layout.</li>
        <li><strong>normalizedBbox:</strong> Specifies normalized bounding box coordinates (left, top, bottom, right) relative to the image dimensions.</li>
        </ul>

        <h3 class="headingThree text-blue">Building an OCR AI Agent in Anydone AI Studio</h3>
        // ocr 1
        <video-component src="https://edge-a.anydone.com/treeleaf/0f5f2b98-bf5e-455a-9fea-d68e348d5906.mp4"></video-component>
        // ocr 2
        <video-component src="https://edge-a.anydone.com/treeleaf/b3991e99-05bc-4314-97b1-1a282e6f091c.mp4"></video-component>
        <p>n this example, we demonstrate how to build a basic OCR (Optical Character Recognition) AI Agent in anydone AI Studio, explaining why specific blocks have been added to the workflow.</p>
        <p><span class="underline-text">Input Block</span> <br>
        We start by adding an Input block, where the input type is set to Image. Since we are building an OCR AI Agent, it is obvious that the user's input will be an image from which the text needs to be extracted.
        </p>
        <p>
        <span class="underline-text">OCR Process Block</span> <br>
        Next, we select the OCR Process block from AI Models. The input block is connected to the OCR block by selecting the variable $input_1.img, ensuring that the image uploaded by the user is passed correctly to the OCR model for processing.
        </p>
        <p>
        <span class="underline-text">Send Reply Block</span> <br>
        Then, we have added a Send Reply block. This block is responsible for delivering the extracted text back to the user. It is connected to the OCR Process block by selecting the variable $ocr_process_1.rawText. Choosing this variable ensures that the agent replies with the raw text output extracted from the submitted image.
        </p>
        <p>
        <span class="underline-text">Log Blocks (Optional)</span> <br>
        We have also added Log blocks after each key action — both for success and error cases.These logs are useful for tracking the agent's behavior, debugging any failures, and monitoring successful operations.
        </p>
        `
    },
    "how-to-create-grammar-check":{
        title:"Grammar Check",
        content:`
        <ul class="steps-list">
          <li>Log in to your anydone account.</li>
          <li>Click on the <strong>Automation Tools</strong> icon from the left side of your dashboard.</li>
          <li>Select the <strong>Process</strong> option.</li>
          <li>Click the <strong>+</strong> button from the bottom-right corner.</li>
          <li>Enter a <strong>name</strong> and <strong>description</strong> for the process.</li>
          <li>Under <strong>Type</strong>, search for and select <strong>Grammar Check </strong>option .</li>
          <li>Under <strong>Model</strong> >> <strong>Anydone Model</strong></li>
          <li><strong>Define input</strong> and <strong>Output</strong> settings.</li>
          <li>Finally, click the <strong>Create</strong> button.</li>
          </ul>

        <h3 class="headingTwo underline-text">Configuring the Grammar Check Process:</h3>
        <p>If you want to build a Grammar Process using another model, first you need to integrate a third-party model. Then, under Type , select the created model, or you can use the default AnyDone model and continue building.</p>
        <p>Afterward, if you have created a prompt for the Grammar, you need to select that specific prompt. Otherwise, this field is optional, and you can continue without it.</p>

        <h3 class="headingThree text-blue">Input Components:</h3>
        <ul class="no-listing">
        <li><i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Input Name:</span> Include text and it cannot be edited.</li>
        <li><i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Mapping Name:</span> The default mapping name is editable.</li>
        <li><i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Mapping Description:</span> Optional; users can provide a description for the mapping if needed.</li>
        <li><i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Input Type:</span> Choose between Dynamic or Static:
        <ul class="no-listing">
            <li><span class="underline-text">If input Data Type is Static:</span> Define inputs within the Process, and then it will generate output based on the mapped input, once mapped and triggered you cannot change it later.
            <ul>
            <li>Under Data Type >> Value > add the text</li>
            </ul>
            </li>
            <li><span class="underline-text">If input Data Type is Dynamic:</span> You need to leave its field as it is, you don't have to define anything in the Process. 
            </li>
            </ul>
        </li>
        </ul>

        <h3 class="headingThree text-blue">Output Components:</h3>
        <p>
        You need to select the outputs from the output sample, then output fields will be mapped automatically upon selection.
        </p>
        <p><i class="fa-solid fa-arrow-right-long"></i> <strong>Editable Fields</strong></p>
        <ul>
        <li>Mapping Name and Mapping Description can be edited.</li>
        </ul>
        <p>
        <strong>Note:</strong> Once you mapped the outputs from the Output sample, it is recommended not to make any type of changes to the <strong>Mapping Type </strong> and <strong>Map To</strong> fields.
        </p>

        <h3 class="headingThree text-blue">Output Sample:</h3>
        <p><i class="fa-solid fa-arrow-right-long"></i> replyText: "reply"   -  Your text will be visible as reply</p>

        <h3 class="headingThree">Building an Grammar Check AI Agent in Anydone AI Studio</h3>

        // grammer 1
        <video-component src="https://edge-a.anydone.com/treeleaf/1a9b306b-d853-43d5-9799-ce20c0c9fd26.mp4"></video-component>
        // grammer 2
        <video-component src="https://edge-a.anydone.com/treeleaf/e9805c4b-e19e-4490-b4f8-2ccdd55cfd32.mp4"></video-component>
        <p>In this example, we explain how to build a basic Grammar Check AI Agent in anydone AI Studio. This enables the AI Agent to receive a text input, check it for grammatical errors, and return a corrected version.</p>
        <p>
        <span class="underline-text">Input Blocks</span> <br>
        We begin by adding an Input block where the input type is set to Text. Since the purpose of this AI Agent is to perform grammar checking, it is essential that the user provides text as the input. 
        </p>
        <p>
        <span class="underline-text">Grammar Check Process Block</span> <br>
        Next, we add the Grammar Check Process block from the AI Model. This block is designed to analyze the input text for grammatical mistakes. We connect the Input block to the Grammar Check Process block by referencing the variable $input_1.query - ensuring the user’s submitted text is properly passed for grammar analysis.
        </p>
        <p>
        <span class="underline-text">Send Reply Block</span> <br>
        After processing the input text, we use a Send Reply block to deliver the corrected version back to the user. This block is linked to the Grammar Check Process block by selecting the variable $grammar_process_1.replyText. This setup ensures that the user receives a clear and corrected version of their original text as the final output.
        </p>
        <p>
        <span class="underline-text">Log Blocks (Optional)</span> <br>
        We have also added Log blocks to capture both success and error events at each stage.
        Adding logs is a best practice as it allows you to monitor the AI Agent’s performance, debug issues efficiently, and maintain a complete activity history. 
        </p>
        `
    },
    "how-to-create-translation":{
        title:"Translation",
        content:`
        <ul class="steps-list">
          <li>Log in to your anydone account.</li>
          <li>Click on the <strong>Automation Tools</strong> icon from the left side of your dashboard.</li>
          <li>Select the <strong>Process</strong> option.</li>
          <li>Click the <strong>+</strong> button from the bottom-right corner.</li>
          <li>Enter a <strong>name</strong> and <strong>description</strong> for the process.</li>
          <li>Under <strong>Type</strong>, search for and select <strong>Translation </strong>option .</li>
          <li>Under <strong>Model</strong> >> <strong>Anydone Model</strong></li>
          <li><strong>Define input</strong> and <strong>Output</strong> settings.</li>
          <li>Finally, click the <strong>Create</strong> button.</li>
        </ul>

        <h3 class="headingTwo underline-text">Configuring the Translation Process:</h3>
        <h3 class="headingThree text-blue">Input Components:</h3>
        <ul class="no-listing">
        <li>
        <i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Input Name:</span> Includes Text, source language, and destination language, these names cannot be edited.
        </li>
        <li>
        <i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Mapping Name:</span> Editable for all inputs.
        </li>
        <li>
        <i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Mapping Description:</span> Optional; users can provide descriptions for the mapping.
        </li>
        <li>
        <i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Input Type:</span> Choose between Dynamic or Static:
        <ul class="no-listing">
            <li><span class="underline-text">If input Data Type is Static:</span> Define inputs within the Process, and then it will generate output based on the mapped input, once mapped and triggered you cannot change it later.
            <ul>
                <li>Text: Define the text to translate.</li>
                <li>source language: Specify the source language of the text.</li>
                <li>destination language: Specify in which language you want to translate.</li>
            </ul>
            </li>
            <li><span class="underline-text">If input Data Type is Dynamic:</span> You need to leave its field as it is, you don't have to define anything in the Process. 
            </li>
            </ul>
        </li>
        </ul>

        <h3 class="headingThree text-blue">Output Components:</h3>
        <p>
        You need to select the outputs from the output sample, then output fields will be mapped automatically upon selection.
        </p>
        <p><i class="fa-solid fa-arrow-right-long"></i> <strong>Editable Fields</strong></p>
        <ul>
        <li>Mapping Name and Mapping Description can be edited.</li>
        </ul>
        <p>
        <strong>Note:</strong> Once you mapped the outputs from the Output sample, it is recommended not to make any type of changes to the <strong>Mapping Type </strong> and <strong>Map To</strong> fields.
        </p>

        <h3 class="headingThree text-blue">Output Sample:</h3>
        <p><i class="fa-solid fa-arrow-right-long"></i> translatedText: "translated text"     -   Select the sample for the text to be translated</p>

        <h3 class="headingThree">Building a Translation AI Agent in anydone AI Studio</h3>
        <strong>1translat 2translat</strong>

        // translation 1
        <video-component src="https://edge-a.anydone.com/treeleaf/e47e0372-f523-48e3-a83a-a47b01bdb872.mp4"></video-component>

        // translation 2
        <video-component src="https://edge-a.anydone.com/treeleaf/25473759-5006-444b-9dce-f5768b50518f.mp4"></video-component>

        <p>The Translation AI Agent is designed to automatically translate text from one language to another—in this case, from English to Dutch. This agent is especially useful for customer support, multilingual content delivery, and global communications.
        </p>
        <p>
        <span class="underline-text">Input Blocks</span> <br>
        We begin by adding the Input Block and setting the type to Text. This allows users to enter a sentence or paragraph in English, which the AI agent will then translate.
        </p>
        <p>
        <span class="underline-text">Translation Process Block</span> <br>
        Next, we add the Translation Process block from the AI Models section. This block performs the core translation from English to Dutch. Source Language: English, Destination Language: Dutch, then connected Input block with $input_1.query
        </p>
        <p>
        <span class="underline-text">Send Reply Block</span> <br>
        After translation, the output needs to be delivered back to the user. For this, we use the Send Reply Block, which is connected to the Translation Process block through the following variable:
        <ul>
            <li><strong>$translation_process_1.translatedText</strong></li>
        </ul>
        </p>
        <p>This variable contains the final translated text in Dutch. </p>
        <p>
        <span class="underline-text">Log Blocks (Optional)</span> <br>
        Throughout the flow, Log blocks have been added to capture both success and error cases.
        Adding logs ensures better traceability of how the AI Agent is performing, helps in identifying any failures quickly, and offers insights for further optimization. 
        </p>
        `
    },
    "how-to-create-text-summarization":{
        title:"Text Summarization",
        content:`
         <ul class="steps-list">
          <li>Log in to your anydone account.</li>
          <li>Click on the <strong>Automation Tools</strong> icon from the left side of your dashboard.</li>
          <li>Select the <strong>Process</strong> option.</li>
          <li>Click the <strong>+</strong> button from the bottom-right corner.</li>
          <li>Enter a <strong>name</strong> and <strong>description</strong> for the process.</li>
          <li>Under <strong>Type</strong>, search for and select <strong>Text Summarization</strong> option .</li>
          <li>Under <strong>Model</strong> >> <strong>Anydone Model</strong></li>
          <li><strong>Define input</strong> and <strong>Output</strong> settings.</li>
          <li>Finally, click the <strong>Create</strong> button.</li>
        </ul>

        <h3 class="headingTwo underline-text">Configuring the Text Summarization Process:</h3>
        <p>
        If you want to build a Text Summarization Process using another model, first you need to integrate a third-party model. Then, under Type , select the created model, or you can use the default Anydone model and continue building.
        </p>
        <p>
        Afterward, if you have created a Prompt for the Text Summarization, you need to select that specific prompt. Otherwise, this field is optional, and you can continue without it.
        </p>

        <h3 class="headingThree text-blue">Input Components:</h3>
        <ul class="no-listing">
        <li>
        <i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Input Name:</span> Include text and it cannot be edited.
        </li>
        <li>
        <i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Mapping Name:</span> Editable for all inputs.
        </li>
        <li>
        <i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Mapping Description:</span> Optional; users can provide descriptions for the mapping.
        </li>
        <li>
        <i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Input Type:</span> Choose between Dynamic or Static:
        <ul class="no-listing">
            <li><span class="underline-text">Define inputs within the Process, and then it will generate output based on the mapped input, once mapped and triggered you cannot change it later.
            <ul>
                <li>Text: Define the text to summarize.</li>
            </ul>
            </li>
            <li><span class="underline-text">If input Data Type is Dynamic:</span> You need to leave its field as it is, you don't have to define anything in the Process. 
            </li>
            </ul>
        </li>
        </ul>

        <h3 class="headingThree text-blue">Output Components:</h3>
        <p>
        You need to select the outputs from the output sample, then output fields will be mapped automatically upon selection.
        </p>
        <p><i class="fa-solid fa-arrow-right-long"></i> <strong>Editable Fields</strong></p>
        <ul>
        <li>Mapping Name and Mapping Description can be edited.</li>
        </ul>
        <p>
        <strong>Note:</strong> Once you mapped the outputs from the Output sample, it is recommended not to make any type of changes to the <strong>Mapping Type </strong> and <strong>Map To</strong> fields.
        </p>

         <h3 class="headingThree text-blue">Output Sample:</h3>
        <p><i class="fa-solid fa-arrow-right-long"></i> summarizedContent: "Summary of input text or documents"   - Select the sample to summarize the text. </p>

        <h3 class="headingThree">Building a Text Summarization AI Agent in anydone AI Studio</h3>
        <strong>1summar 2summar </strong>
        <p>
        In this example, we walk through how to build a Text Summarization AI Agent in anydone AI Studio. This agent takes a user query, retrieves the relevant information from the knowledge base, summarizes it, and returns a concise reply.
        </p>
        <p>
        <span class="underline-text">Input Blocks</span> <br>
        We start by adding an Input block with the input type set to Text. Since the AI Agent needs a query or statement to process, it is natural for the input to be text-based.
        </p>
        <p>
        <span class="underline-text">Knowledge Engine (anydone Knowledge Base)</span> <br>
        Next, we add a Knowledge Engine block, built with the anydone Knowledge Base. This block is responsible for retrieving the most relevant information based on the user's input. It is connected to the Input block through the variable $input_1.query, meaning that the text submitted by the user is used to fetch an appropriate answer from anydone's knowledge base.
        </p>
        <p>
        <span class="underline-text">Text Summarization Process Block</span> <br>
        Now, we have added a Text Summarization block from the AI Models. This block is designed to compress the retrieved information into a shorter format. It is connected to the Knowledge Engine block by referencing the variable $kbanydone_1.text. This ensures that the AI Agent takes the fetched knowledge base reply and summarizes it intelligently before sending it to the user.
        </p>
        <p>
        <span class="underline-text">Send Reply Block</span> <br>
        Finally, we add a Send Reply block to deliver the summarized text back to the user. This block is linked to the Text Summarization Process block using the variable $text_summarization_process_1.summarizedContent  - this guarantees that the user receives a well-compressed, easy-to-read summary based on their original query.
        </p>
        <p>
        <span class="underline-text">Log Blocks (Optional)</span> <br>
        Throughout the workflow, we have added Log blocks to capture both success and error events for each key step. Adding logs is highly recommended as it helps track the AI Agent’s operations, debug any issues efficiently, and provides valuable insights into user interactions. 
        </p>

        // summar 1
        <video-component src="https://edge-a.anydone.com/treeleaf/35627f69-8125-4f1e-bf4c-eefdd6147029.mp4"></video-component>

        // summar 2
        <video-component src="https://edge-a.anydone.com/treeleaf/3b8a4f04-b78d-4fc1-8f4d-06453a51d6e4.mp4"></video-component>
        `
    },
    "how-to-create-object-detection":{
        title:"Object Detection",
        content:`
        <ul class="steps-list">
          <li>Log in to your anydone account.</li>
          <li>Click on the <strong>Automation Tools</strong> icon from the left side of your dashboard.</li>
          <li>Select the <strong>Process</strong> option.</li>
          <li>Click the <strong>+</strong> button from the bottom-right corner.</li>
          <li>Enter a <strong>name</strong> and <strong>description</strong> for the process.</li>
          <li>Under <strong>Type</strong>, search for and select <strong>Object detection</strong> option .</li>
          <li>Under <strong>Model</strong> >> <strong>Anydone Model</strong></li>
          <li><strong>Define input</strong> and <strong>Output</strong> settings.</li>
          <li>Finally, click the <strong>Create</strong> button.</li>
        </ul>

        <h3 class="headingTwo underline-text">Configuring the Object Detection Process:</h3>
        <h3 class="headingThree text-blue">Input Components:</h3>
        <ul class="no-listing">
        <li>
        <i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Input Name:</span> Include the image and it cannot be edited.
        </li>
        <li>
        <i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Mapping Name:</span> The Default mapping name is editable for input.
        </li>
        <li>
        <i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Mapping Description:</span> Optional; users can provide descriptions for the mapping.
        </li>
        <li>
        <i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Input Type:</span> Choose between Dynamic or Static:
        <ul class="no-listing">
            <li><span class="underline-text">Define inputs within the Process, and then it will generate output based on the mapped input, once mapped and triggered you cannot change it later.
            <ul>
                <li>Upload an image or file, or provide a URL.</li>
            </ul>
            </li>
            <li><span class="underline-text">If input Data Type is Dynamic:</span> You need to leave its field as it is, you don't have to define anything in the Process. 
            </li>
            </ul>
        </li>
        </ul>

        <h3 class="headingThree text-blue">Output Components:</h3>
        <p>
        You need to select the outputs from the output sample, then output fields will be mapped automatically upon selection.
        </p>
        <p><i class="fa-solid fa-arrow-right-long"></i> <strong>Editable Fields</strong></p>
        <ul>
        <li>Mapping Name and Mapping Description can be edited.</li>
        </ul>
        <p>
        <strong>Note:</strong> Once you mapped the outputs from the Output sample, it is recommended not to make any type of changes to the <strong>Mapping Type </strong> and <strong>Map To</strong> fields.
        </p>

        <h3 class="headingThree text-blue">Output Components:</h3>
        <p>
        You need to select the outputs from the output sample, then output fields will be mapped automatically upon selection.
        </p>
        <p><i class="fa-solid fa-arrow-right-long"></i> <strong>Editable Fields</strong></p>
        <ul>
        <li>
        <strong>lassName:</strong> Represents the name or category of the detected object (e.g., "Object1," "Object2").
        </li>
        <li>
        <strong>confidence:</strong> Indicates the confidence level (ranging from 0 to 1) for detecting the object, where higher values reflect greater certainty (e.g., 0.85 for "Object1").
        </li>
         <li>
        <strong>value:</strong> Contains additional information or metadata about the detected object (e.g., "object value").
        </li>
        <li>
        <strong>bbox (Bounding Box):</strong>Specifies the coordinates of the bounding box for the detected object—left: x-coordinate of the left edge, top: y-coordinate of the top edge, bottom: y-coordinate of the bottom edge, and right: x-coordinate of the right edge.
        </li>
        </ul>

        <h3 class="headingThree">Building an Object Detection AI Agent in anydone </h3>
        <strong>1ob 2ob</strong>

        // object 1
        <video-component src="https://edge-a.anydone.com/treeleaf/11f2dd73-dee2-472a-8abe-514a6818dbac.mp4"></video-component>
        // object 2
        <video-component src="https://edge-a.anydone.com/treeleaf/8a797233-409b-438c-abfd-51b6c6d7b200.mp4"></video-component>
        <p>
        In this example, we explain how to build a basic Object Detection AI Agent in anydone AI Studio. This AI Agent will be able to receive an image, detect objects within it, and return both the object name and its confidence value.
        </p>
        <p>
        <span class="underline-text">Input Blocks</span> <br>
        We start by adding an Input block with the input type set to Image. Since the goal of this AI Agent is to detect objects within an image, it’s obvious that the user needs to upload an image as input. 
        </p>
        <p>
        <span class="underline-text">Object Detection Process Block</span> <br>
        Next, we add the Object Detection Process block from the AI Models. This block processes the input image to identify and classify objects present in it. It is connected to the Input block through the variable $input_1.img.
        </p>
        <p>
        <span class="underline-text">Send Reply Block</span> <br>
        After detecting objects in the image, we add a Send Reply block to deliver the results back to the user. This block is connected to the Object Detection Process block by selecting two important variables:
        </p>
        <p>
        <strong>$object_detection_1.className:</strong>
         This variable returns the name of the detected object (for example, "dog", "car", or "bottle").
        </p>
        <p>
        <strong>object_detection_1.value:</strong>
        This variable provides the confidence score or probability of the detection, indicating how certain the AI model is about its prediction (for example, 0.92 meaning 92% confidence).
        </p>
        <p>
        By sending both the class name and the confidence value, the AI Agent provides a complete and clear result to the user.
        </p>
        <p>
        <span class="underline-text">Log Blocks (Optional)</span> <br>
        Throughout the flow, Log blocks have been added to capture both success and error cases.
        Adding logs ensures better traceability of how the AI Agent is performing, helps in identifying any failures quickly, and offers insights for further optimization. 
        </p>
        `
    },
    "how-to-create-face-detection":{
        title:"Object Detection",
        content:`
        <ul class="steps-list">
          <li>Log in to your anydone account.</li>
          <li>Click on the <strong>Automation Tools</strong> icon from the left side of your dashboard.</li>
          <li>Select the <strong>Process</strong> option.</li>
          <li>Click the <strong>+</strong> button from the bottom-right corner.</li>
          <li>Enter a <strong>name</strong> and <strong>description</strong> for the process.</li>
          <li>Under <strong>Type</strong>, search for and select <strong>Object detection</strong> option .</li>
          <li>Under <strong>Model</strong> >> <strong>Anydone Model</strong></li>
          <li><strong>Define input</strong> and <strong>Output</strong> settings.</li>
          <li>Finally, click the <strong>Create</strong> button.</li>
        </ul>
        `
    },
    "how-to-create-face-recognition":{
        title:"Face recognition",
        content:`
        <ul class="steps-list">
          <li>Log in to your anydone account.</li>
          <li>Click on the <strong>Automation Tools</strong> icon from the left side of your dashboard.</li>
          <li>Select the <strong>Process</strong> option.</li>
          <li>Click the <strong>+</strong> button from the bottom-right corner.</li>
          <li>Enter a <strong>name</strong> and <strong>description</strong> for the process.</li>
          <li>Under <strong>Type</strong>, search for and select <strong>Face Recognition</strong> option .</li>
          <li>Under <strong>Model</strong> >> <strong>Anydone Model</strong></li>
          <li><strong>Define input</strong> and <strong>Output</strong> settings.</li>
          <li>Finally, click the <strong>Create</strong> button.</li>
        </ul>

        <h3 class="headingTwo underline-text">Configuring the Object Detection Process:</h3>
        <h3 class="headingThree text-blue">Input Components:</h3>
        <ul class="no-listing">
        <li>
        <i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Input Name:</span> Includes image-source1 and image-source2 and this cannot be edited.
        </li>
        <li>
        <i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Mapping Name:</span> The Default mapping name is editable for input.
        </li>
        <li>
        <i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Mapping Description:</span> Optional; users can provide descriptions for the mapping.
        </li>
        <li>
        <i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Input Type:</span> Choose between Dynamic or Static:
        <ul class="no-listing">
            <li><span class="underline-text">If input Data Type is Static: </span>Define inputs within the Process, and then it will generate output based on the mapped input, once mapped and triggered you cannot change it later.
            <ul>
                <li>Upload an image or file, or provide a URL.</li>
            </ul>
            </li>
            <li><span class="underline-text">If input Data Type is Dynamic:</span> You need to leave its field as it is, you don't have to define anything in the Process. 
            </li>
            </ul>
        </li>
        </ul>

        <h3 class="headingThree text-blue">Output Components:</h3>
        <p>
        You need to select the outputs from the output sample, then output fields will be mapped automatically upon selection.
        </p>
        <p><i class="fa-solid fa-arrow-right-long"></i> <strong>Editable Fields</strong></p>
        <ul>
        <li>Mapping Name and Mapping Description can be edited.</li>
        </ul>
        <p>
        <strong>Note:</strong> Once you mapped the outputs from the Output sample, it is recommended not to make any type of changes to the <strong>Mapping Type </strong> and <strong>Map To</strong> fields.
        </p>

        <h3 class="headingThree text-blue">Output Sample:</h3>
        <p><i class="fa-solid fa-arrow-right-long"></i> summarizedContent: "Summary of input text or documents"   - Select the sample to summarize the text. </p>

        <h3 class="headingThree">Building a Face Recognition AI Agent in Anydone </h3>

        // fc 1
        <video-component src="https://edge-a.anydone.com/treeleaf/4558b24b-9fb5-41e4-b7ad-bfc0b46ed71f.mp4"></video-component>
        // fc 2
        <video-component src="https://edge-a.anydone.com/treeleaf/dc9acd03-1fcb-429f-af9e-3c0e8acd2aac.mp4"></video-component>
        <p>
        In this example, we will walk through how to build a basic Face Recognition AI Agent in anydone AI Studio.
        </p>
        <p>
        <span class="underline-text">Input Block</span> <br>
        We start by adding an Input block where two inputs are defined: imgFirst and imgSecond. Since face recognition requires two images. These inputs serve as the foundation for the face recognition process.
        </p>
        <p>
        <span class="underline-text">Face Recognition Process Block</span> <br>
        Next, we add the Face Recognition Process block from the AI Models. It is connected to the Input block using both variables:
        </p>
        <p>
        <strong">$input_1.imgFirst:</strong> <br>
         The first image input uploaded by the user.
        </p>
        <p>
        <strong">$input_2.imgSecon:</strong> <br>
         The second image input uploaded by the user.
        </p>
        <p>
        <p>
        <span class="underline-text">Send Reply Block</span> <br>
        After that, we added a Send Reply block that will send output whether the faces match or do not match, along with a confidence score (depending on how the model has been set up).
        </p>
         <p>
        <span class="underline-text">Log Blocks (Optional)</span> <br>
        Throughout the flow, Log blocks are added after every major step for both success and error cases. Adding logs helps you monitor the AI Agent's behavior, diagnose issues easily if something goes wrong, and improve the overall reliability and traceability of your face recognition flows. 
        </p>
        `
    },
    "how-to-create-image-comparison":{
        title:"Image comparison",
        content:`
        <p>
        There are two approaches to build AI Agents for Image Comparison : 
        </p>
        <ul class="no-listing">
        <li>
            <strong> Using the Anydone Model:</strong>
            This option requires no additional configuration or setup. Simply select the <strong> Anydone Model</strong> while creating the Image Comparison <span class="text-blue">Process<span>, and seamlessly build your AI Agent.
        </li>
        <li>
            <strong> Integrating Third-Party Models:</strong>
             If you prefer a <span class="text-blue">third-party provider </span>, you need to <span class="text-blue">integrate it </span> first. After integration, make sure the model type is configured correctly. Meaning, regardless of the provider, you must specify the right model type. Likewise, for Image Comparison, select the model specific to the integrated third party platform.
        </li>
        </ul>

        <ul class="steps-list">
          <li>Log in to your anydone account.</li>
          <li>Click on the <strong>Automation Tools</strong> icon from the left side of your dashboard.</li>
          <li>Select the <strong>Process</strong> option.</li>
          <li>Click the <strong>+</strong> button from the bottom-right corner.</li>
          <li>Enter a <strong>name</strong> and <strong>description</strong> for the process.</li>
          <li>Under <strong>Type</strong>, search for and select <strong>Image Comparison</strong> option .</li>
          <li>Under Model, choose your preferred model <br>
            (Select between the Anydone Model or a third-party model)
            </li>
          <li><strong>Define input</strong> and <strong>Output</strong> settings.</li>
          <li>Finally, click the <strong>Create</strong> button.</li>
        </ul>

        <h3 class="headingTwo underline-text">Configuring the Image Comparison Process:</h3>
        <h3 class="headingThree text-blue">Input Components:</h3>
        <ul class="no-listing">
        <li>
        <i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Input Name:</span> Includes image1, image2, prompt these names are fixed and cannot be edited.
        </li>
        <li>
        <i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Mapping Name:</span> Editable for all inputs.
        </li>
        <li>
        <i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Mapping Description:</span> Optional; users can provide descriptions for the mapping.
        </li>
        <li>
        <i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Input Type:</span> Choose between Dynamic or Static:
        <ul class="no-listing">
            <li><span class="underline-text">If input Data Type is Static: </span>Define inputs within the Process, and then it will generate output based on the mapped input, once mapped and triggered you cannot change it later.
            <ul>
                <li>image1: add the first image to compare.</li>
                <li>image2: add the second image to compare.</li>
                <li>prompt: Add text that defines what details need to be compared from the provided images.</li>
            </ul>
            </li>
            <li><span class="underline-text">If input Data Type is Dynamic:</span> You need to leave its field as it is, you don't have to define anything in the Process. 
            </li>
            </ul>
        </li>
        </ul>

        <h3 class="headingThree text-blue">Output Components:</h3>
        <p>
        You need to select the outputs from the output sample, then output fields will be mapped automatically upon selection.
        </p>
        <p><i class="fa-solid fa-arrow-right-long"></i> <strong>Editable Fields</strong></p>
        <ul>
        <li>Mapping Name and Mapping Description can be edited.</li>
        </ul>
        <p>
        <strong>Note:</strong> Once you mapped the outputs from the Output sample, it is recommended not to make any type of changes to the <strong>Mapping Type </strong> and <strong>Map To</strong> fields.
        </p>

        <h3 class="headingThree text-blue">Output Sample:</h3>
        <p><i class="fa-solid fa-arrow-right-long"></i> visualInterpretResult: Provides the elaborated analysis of compared images </p>
        <p><i class="fa-solid fa-arrow-right-long"></i> text: Contains the description or summary of the images</p>

        <h3 class="headingThree">Building an Image Comparison AI Agent in anydone Studio</h3>

        // ic 1
        <video-component src="https://edge-a.anydone.com/treeleaf/3530a627-b970-4156-adaa-b5bc498c55da.mp4"</video-component>
        // ic 2
        <video-component src="https://edge-a.anydone.com/treeleaf/edcfeb26-aa07-4d1e-90e7-1afada105a33.mp4"</video-component>
        <p>
        In this guide, we'll walk through how to build an Image Comparison AI Agent using anydone Studio. This AI Agent allows users to upload two images, optionally provide a text prompt, and receive a result comparing the two images using AI.
        </p>
        <p>
        <span class="underline-text">Input Block</span> <br>
        We begin by adding an Input block that accepts two required image fields and one optional text input, image: The first image to be compared,  image1: The second image to be compared. text (optional): Additional user instructions or context related to the comparison, such as "Check if both images contain the same object."  This allows the AI Agent to compare two images directly, while taking into account any descriptive context the user wants to provide.
        </p>
        <p>
        <span class="underline-text">Image Comparison Process Block</span> <br>
        Next, we add the Image Comparison Process block from the AI Models section. This block analyzes the two uploaded images and optionally uses the text input to guide the comparison.
        Connect the Image Comparison Process block with the following variables from the Input block, $input_1.image — First $input_1.image1 and if you have added text in input then here in prompt enter $ and select the variable input_1.text.
        </p>
        <p>
        <span class="underline-text">Send Reply Block</span> <br>
        Once the images are processed and a comparison result is generated, we use the Send Reply block to deliver the response to the user. Connect this block using the variable, $image_comparison_process_1.text - this gives the textual result of the image comparison.
        </p>
        <p>
        <span class="underline-text">Log Blocks </span> <br>
        Throughout the blocks, Log blocks are added after every major step for both success and error cases. Adding logs helps you monitor the AI Agent's behavior, diagnose issues easily if something goes wrong, and improve the overall reliability and traceability of your face recognition flows. 
        </p>
        `
    },
    "how-to-create-image-generation":{
        title:"Image generation",
        content:`
        <p>There are two approaches to build AI Agents for Image Generation in anydone:</p>
        <ul class="no-listing">
        <li>
            <strong> Using the Anydone Model:</strong>
            This option requires no additional configuration or setup. Simply select the Anydone Model while creating the Image Generation Process, and seamlessly build your AI Agent.
        </li>
        <li>
            <strong> Integrating Third-Party Models:</strong>
             If you prefer a third-party provider, you need to integrate it first. After integration, make sure the model type is configured correctly. Meaning, regardless of the provider, you must specify the right model type. Likewise, for Image Generation, select the model specific to it from the integrated third party platform.
        </li>
        </ul>
        <ul class="steps-list">
          <li>Log in to your anydone account.</li>
          <li>Click on the <strong>Automation Tools</strong> icon from the left side of your dashboard.</li>
          <li>Select the <strong>Process</strong> option.</li>
          <li>Click the <strong>+</strong> button from the bottom-right corner.</li>
          <li>Enter a <strong>name</strong> and <strong>description</strong> for the process.</li>
          <li>Under <strong>Type</strong>, search for and select <strong>Image Generation</strong> option .</li>
          <li>Under Model, choose your preferred model <br>
            (Select between the Anydone Model or a third-party model)
            </li>
          <li><strong>Define input</strong> and <strong>Output</strong> settings.</li>
          <li>Finally, click the <strong>Create</strong> button.</li>
        </ul>

        <h3 class="headingTwo underline-text">Configuring the Image Generation Process:</h3>
        <h3 class="headingThree text-blue">Input Components:</h3>
        <ul class="no-listing">
        <li>
        <i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Input Name:</span> Includes prompt, and this name is fixed and cannot be edited.
        </li>
        <li>
        <i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Mapping Name:</span> Editable for all inputs.
        </li>
        <li>
        <i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Mapping Description:</span> Optional; users can provide descriptions for the mapping.
        </li>
        <li>
        <i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Input Type:</span> Choose between Dynamic or Static:
        <ul class="no-listing">
            <li><span class="underline-text">If input Data Type is Static: </span>Define inputs within the Process, and then it will generate output based on the mapped input, once mapped and triggered you cannot change it later.
            <ul>
                <li>prompt: add the text defining what type of image to generate.</li>
            </ul>
            </li>
            <li><span class="underline-text">If input Data Type is Dynamic:</span> You need to leave its field as it is, you don't have to define anything in the Process. 
            </li>
            </ul>
        </li>
        </ul>

        <h3 class="headingThree text-blue">Output Components:</h3>
        <p>
        You need to select the outputs from the output sample, then output fields will be mapped automatically upon selection.
        </p>
        <p><i class="fa-solid fa-arrow-right-long"></i> <strong>Editable Fields</strong></p>
        <ul>
        <li>Mapping Name and Mapping Description can be edited.</li>
        </ul>
        <p>
        <strong>Note:</strong> Once you mapped the outputs from the Output sample, it is recommended not to make any type of changes to the <strong>Mapping Type </strong> and <strong>Map To</strong> fields.
        </p>

        <h3 class="headingThree text-blue">Output Sample:</h3>
        <p><i class="fa-solid fa-arrow-right-long"></i> imageUrls -  You will get the url for the generated image. </p>

        <h3 class="headingThree">Building an Image Generation AI Agent in anydone AI Studio</h3>
        <strong>1ig 2ig</strong>

        // ig 1
        <video-component src="https://edge-a.anydone.com/treeleaf/33fa15c6-d492-4f35-9e21-f219092bbf2d.mp4"></video-component>
       // ig 2
        <video-component src="https://edge-a.anydone.com/treeleaf/b3b85159-3d7e-4f2d-9cbe-83ef6809aa9a.mp4"></video-component>
        <p>
        In this flow, we’ll build a basic Image Generation AI Agent using anydone Studio. This agent takes a text-based prompt from the user and generates a relevant image using AI. Let’s explore how each block is added and why it’s essential to the process.
        </p>
        <p>
        <span class="underline-text">Input Block</span> <br>
        We begin with an Input block where the input type is set to Text. This field, labeled query, allows users to enter a descriptive prompt for images.
        </p>
        <p>
        <span class="underline-text">Image Generation Process Block</span> <br>
        Next, we add the Image Generation Process block from the AI Models section. We connect this block with the input block using the variable, $input_1.query this passes the user's text input directly into the image generation model.
        </p>
        <p>
        <span class="underline-text">Send Reply Block</span> <br>
        To return the generated image(s) to the user, we add a Send Reply block. It is connected to the Image Generation Process block using the variable $image_generation_1.imageUrls
        </p>
        <p>
        <span class="underline-text">Log Blocks </span> <br>
        Throughout the blocks, Log blocks are added after every major step for both success and error cases. Adding logs helps you monitor the AI Agent's behavior, diagnose issues easily if something goes wrong, and improve the overall reliability and traceability of your face recognition flows. 
        </p>
        `
    },
    "how-to-create-image-understanding":{
        title:"Image Understanding",
        content:`
        <p>The Image Understanding process has the ability to analyze and interpret images. It can recognize objects, people, text, colors, and scenes from the image. It can process visual details and extracts meaningful information.</p>
        <p>There are two approaches to build AI Agents for Image Understanding in anydone: </p>
        <ul class="no-listing">
        <li>
            <strong> Using the Anydone Model:</strong>
            This option requires no additional configuration or setup. Simply select the Anydone Model while creating the Image understating Process, and seamlessly build your AI Agent.
        </li>
        <li>
            <strong> Integrating Third-Party Models:</strong>
            If you prefer a third-party provider, you need to integrate it first. After integration, make sure the model type is configured correctly. Meaning, regardless of the provider, you must specify the right model type. Likewise, for Image Understanding, select the model specific to it from the integrated third party platform.
        </li>
        </ul>
        <ul class="steps-list">
          <li>Log in to your anydone account.</li>
          <li>Click on the <strong>Automation Tools</strong> icon from the left side of your dashboard.</li>
          <li>Select the <strong>Process</strong> option.</li>
          <li>Click the <strong>+</strong> button from the bottom-right corner.</li>
          <li>Enter a <strong>name</strong> and <strong>description</strong> for the process.</li>
          <li>Under <strong>Type</strong>, search for and select <strong>Image Understanding</strong> option .</li>
          <li>Under Model, choose your preferred model <br>
            (Select between the Anydone Model or a third-party model)
            </li>
          <li><strong>Define input</strong> and <strong>Output</strong> settings.</li>
          <li>Finally, click the <strong>Create</strong> button.</li>
        </ul>

        <h3 class="headingTwo underline-text">Configuring the Image Generation Process:</h3>
        <h3 class="headingThree text-blue">Input Components:</h3>
        <ul class="no-listing">
        <li>
        <i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Input Name:</span> Includes prompt, and image, this name is fixed and cannot be edited.
        </li>
        <li>
        <i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Mapping Name:</span> Editable for all inputs.
        </li>
        <li>
        <i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Mapping Description:</span> Optional; users can provide descriptions for the mapping.
        </li>
        <li>
        <i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Input Type:</span> Choose between Dynamic or Static:
        <ul class="no-listing">
            <li><span class="underline-text">If input Data Type is Static: </span>Define inputs within the Process, and then it will generate output based on the mapped input, once mapped and triggered you cannot change it later.
            <ul>
                <li>prompt: add the text defining what aspect of the image you want to understand. </li>
                <li>Image: Upload or add the url of the image</li>
            </ul>
            </li>
            <li><span class="underline-text">If input Data Type is Dynamic:</span> You need to leave its field as it is, you don't have to define anything in the Process. 
            </li>
            </ul>
        </li>
        </ul>

        <h3 class="headingThree text-blue">Output Components:</h3>
        <p>
        You need to select the outputs from the output sample, then output fields will be mapped automatically upon selection.
        </p>
        <p><i class="fa-solid fa-arrow-right-long"></i> <strong>Editable Fields</strong></p>
        <ul>
        <li>Mapping Name and Mapping Description can be edited.</li>
        </ul>
        <p>
        <strong>Note:</strong> Once you mapped the outputs from the Output sample, it is recommended not to make any type of changes to the <strong>Mapping Type </strong> and <strong>Map To</strong> fields.
        </p>

        <h3 class="headingThree text-blue">Output Sample:</h3>
        <p><i class="fa-solid fa-arrow-right-long"></i> visualInterpretResult: Provides the complete image analysis.</p>
        <p><i class="fa-solid fa-arrow-right-long"></i> text: Contains the resulting description or summary of the visualInterpretResult. </p>

        <h3 class="headingThree">Building an Image Understanding AI Agent in anydone AI Studio</h3>
        <p>
        Here we'll be building an Image Understanding AI Agent using anydone AI Studio. This agent accepts both a descriptive text query and an image input, enabling it to analyze the image in context and provide an intelligent interpretation.
        </p>
        <p>
        <span class="underline-text">Input Block</span> <br>
        We start with an Input Block, where we define two types of input, Text input (query): This allows the user to describe what they want the agent to analyze or interpret within the image. For example: “What is happening in this image?”, then Image input (image),  the actual image to be analyzed is uploaded or submitted alongside the query.
        </p>
        <p>
        <span class="underline-text">Image Understanding Process Block</span> <br>
        Next, we add the Image Understanding Process block from the AI Models section. We connect this process block to the input using $input_1.query and  $input_1.image together, these variables help the model understand what to look for in the image and how to interpret it based on user intent.
        </p>
        <p>
        <span class="underline-text">Send Reply Block</span> <br>
        To deliver the output, we add a Send Reply Block, which is connected to the process block using the variable $image_understanding_process_1.visualInterpretResult
        </p>
        <p>
        <span class="underline-text">Log Blocks </span> <br>
        Throughout the blocks, Log blocks are added after every major step for both success and error cases. Adding logs helps you monitor the AI Agent's behavior, diagnose issues easily if something goes wrong, and improve the overall reliability and traceability of your face recognition flows. 
        </p>
        `
    },
    "how-to-create-text-generation":{
        title:"Text Generation ",
        content:`
        <p>There are two approaches to build AI Agents for Text Generation in anydone:</p>
        <ul class="no-listing">
        <li>
            <strong> Using the Anydone Model:</strong>
            This option requires no additional configuration or setup. Simply select the Anydone Model while creating the Text Generation Process, and seamlessly build your AI Agent.
        </li>
        <li>
            <strong> Integrating Third-Party Models:</strong>
            If you prefer a third-party provider, you need to integrate it first. After integration, make sure the model type is configured correctly. Meaning, regardless of the provider, you must specify the right model type. Likewise, for Text Generation, select the model specific to it from the integrated third party platform.
        </li>
        </ul>

        <ul class="steps-list">
          <li>Log in to your anydone account.</li>
          <li>Click on the <strong>Automation Tools</strong> icon from the left side of your dashboard.</li>
          <li>Select the <strong>Process</strong> option.</li>
          <li>Click the <strong>+</strong> button from the bottom-right corner.</li>
          <li>Enter a <strong>name</strong> and <strong>description</strong> for the process.</li>
          <li>Under <strong>Type</strong>, search for and select <strong>Text Generation</strong> option .</li>
          <li>Under Model, choose your preferred model <br>
            (Select between the Anydone Model or a third-party model)
            </li>
          <li><strong>Define input</strong> and <strong>Output</strong> settings.</li>
          <li>Finally, click the <strong>Create</strong> button.</li>
        </ul>

        <h3 class="headingTwo underline-text">Configuring the Text Generation Process:</h3>
        <p>If you want to build a Text GenerationProcess using another model, first you need to integrate a third-party model. Then, under Type , select the created model, or you can use the default AnyDone model and continue building.</p>
        <p>Afterward, if you have created a prompt for the Text Generation, you need to select that specific prompt. Otherwise, this field is optional, and you can continue without it.</p>

        <h3 class="headingThree text-blue">Input Components:</h3>
        <ul class="no-listing">
        <li>
        <i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Input Name:</span> Includes prompt, and this name is fixed and cannot be edited.
        </li>
        <li>
        <i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Mapping Name:</span> Editable for all inputs.
        </li>
        <li>
        <i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Mapping Description:</span> Optional; users can provide descriptions for the mapping.
        </li>
        <li>
        <i class="fa-solid fa-arrow-right-long"></i> <span class="underline-text">Input Type:</span> Choose between Dynamic or Static:
        <ul class="no-listing">
            <li><span class="underline-text">If input Data Type is Static: </span>Define inputs within the Process, and then it will generate output based on the mapped input, once mapped and triggered you cannot change it later.
            <ul>
                <li>prompt: add the text as a query </li>
            </ul>
            </li>
            <li><span class="underline-text">If input Data Type is Dynamic:</span> You need to leave its field as it is, you don't have to define anything in the Process. 
            </li>
            </ul>
        </li>
        </ul>

        <h3 class="headingThree text-blue">Output Components:</h3>
        <p>
        You need to select the outputs from the output sample, then output fields will be mapped automatically upon selection.
        </p>
        <p><i class="fa-solid fa-arrow-right-long"></i> <strong>Editable Fields</strong></p>
        <ul>
        <li>Mapping Name and Mapping Description can be edited.</li>
        </ul>
        <p>
        <strong>Note:</strong> Once you mapped the outputs from the Output sample, it is recommended not to make any type of changes to the <strong>Mapping Type </strong> and <strong>Map To</strong> fields.
        </p>
        <h3 class="headingThree text-blue">Output Sample:</h3>
        <p><i class="fa-solid fa-arrow-right-long"></i> replyText: "hello"    -    Select the sample to generate and get the response</p>

        <h3 class="headingThree">Building a Text Generation AI Agent in anydone AI Studio</h3>
        <p>
        The Text Generation AI Agent is designed to generate human-like responses or creative content based on a user’s input prompt. This flow demonstrates how to configure such an agent in anydone Studio.
        </p>
        <p>
        <span class="underline-text">Input Block</span> <br>
        We begin by adding an Input Block where the user will provide a text-based query. This text serves as the prompt for the AI model to generate a meaningful response. Examples of input: “Write a motivational quote.” “Explain the concept of quantum computing in simple terms.” “Generate a title for an article about productivity.”
        </p>
        <p>
        <span class="underline-text">Text Generation Process Block</span> <br>
        Next, we add the Text Generation process block from the AI Models section. This block is responsible for producing the response based on the user's query. We connect the Text Generation block using the variable $input_1.query
        </p>
        <p>
        <span class="underline-text">Send Reply Block</span> <br>
        To display the output to the user, we add a Send Reply Block. This block is connected to the Text Generation Process using the variable $text_generation_1.replyText
        </p>
        <p>
        <span class="underline-text">Log Blocks</span> <br>
        Throughout the blocks, Log blocks are added after every major step for both success and error cases. Adding logs helps you monitor the AI Agent's behavior, diagnose issues easily if something goes wrong, and improve the overall reliability and traceability of your face recognition flows. 
        </p>
        `
    },
    "how-to-create-code-generation":{
        title:"Code Generation",
        content:`
        <p>There are two approaches to build AI Agents for Code Generation in anydone:</p>
        <ul class="no-listing">
        <li>
            <strong> Using the Anydone Model:</strong>
            This option requires no additional configuration or setup. Simply select the Anydone Model while creating the Code Generation Process, and seamlessly build your AI Agent.
            <br>
            thirdPartyModelResponse: {
            <br>
            codeGenerationResponse: 
        </li>
        <li>
            <strong> Integrating Third-Party Models:</strong>
            If you prefer a third-party provider, you need to integrate it first. After integration, make sure the model type is configured correctly. Meaning, regardless of the provider, you must specify the right model type. Likewise, for Code Generation, select the model specific to it from the integrated third party platform.
        </li>
        </ul>

        <ul class="steps-list">
          <li>Log in to your anydone account.</li>
          <li>Click on the <strong>Automation Tools</strong> icon from the left side of your dashboard.</li>
          <li>Select the <strong>Process</strong> option.</li>
          <li>Click the <strong>+</strong> button from the bottom-right corner.</li>
          <li>Enter a <strong>name</strong> and <strong>description</strong> for the process.</li>
          <li>Under <strong>Type</strong>, search for and select <strong>Code Generation</strong> option .</li>
          <li>Under Model, choose your preferred model <br>
            (Select between the Anydone Model or a third-party model)
            </li>
          <li><strong>Define input</strong> and <strong>Output</strong> settings.</li>
          <li>Finally, click the <strong>Create</strong> button.</li>
        </ul>

        <h3 class="headingTwo underline-text">Configuring the Code Generation Process:</h3>
        <p>If you want to build a Code Generation Process using another model, first you need to integrate a third-party model. Then, under Type , select the created model, or you can use the default Anydone model and continue building.</p>
        <p>Afterward, if you have created a prompt for the Code Generation, you need to select that specific prompt. Otherwise, this field is optional, and you can continue without it.</p>

        <h3 class="headingThree text-blue">Output Components:</h3>
        <p>
        You need to select the outputs from the output sample, then output fields will be mapped automatically upon selection.
        </p>
        <p><i class="fa-solid fa-arrow-right-long"></i> <strong>Editable Fields</strong></p>
        <ul>
        <li>Mapping Name and Mapping Description can be edited.</li>
        </ul>
        <p>
        <strong>Note:</strong> Once you mapped the outputs from the Output sample, it is recommended not to make any type of changes to the <strong>Mapping Type </strong> and <strong>Map To</strong> fields.
        </p>
        <h3 class="headingThree text-blue">Output Sample:</h3>
        <ul class="no-listing">
        <li><i class="fa-solid fa-arrow-right-long"></i> thirdPartyModelResponse   -    Generate a code with a third-party model, which generates a response based on the input provided for code generation</li>
        <li><i class="fa-solid fa-arrow-right-long"></i> codeGenerationResponse    -     Contains the response from the third-party model after it processes the code generation request, typically in the form of structured data or outputs.</li>
        <li><i class="fa-solid fa-arrow-right-long"></i> Url     -    Provides the URL or link to the generated code or the resource created by the third-party model, allowing the user to access or use the generated code.</li>
        </ul>
        `
    },
    "how-to-create-input-block":{
        title:"Input Block",
        content:`
        <p>The Input Block in Flowcess is used to define the data your Flowcess workflow needs to receive at the start or during execution. This block acts as a gateway for user-provided values, system-generated inputs, or values passed from external sources. Whether you're collecting text, files, or even structured data like JSON or XML, the Input Block helps you define the format and behavior of that input.</p>

        <h3 class="headingThree underline-text">Configure Input Fields</h3>
        <p>The Input Block consists of three key sections:</p>

        <h3 class="headingThree underline-text">1. Name</h3>
        <p>This is the identifier for your input. It must be unique and meaningful, as it will be used throughout your automation to refer to this specific data point. For example, you might name it userEmail, orderDate, or uploadedImage.</p>

        <h3 class="headingThree underline-text">2. Type</h3>
        <p>This defines what kind of data the input will accept. Flowcess supports a wide range of input types to match your use case:</p>
        <ul>
            <li>Simple Types:
                <ul>
                    <li>Text, Number, Phone, Email, Boolean</li>
                </ul>
            </li>
            <li>Date and Time Types:
                <ul>
                    <li>Now, Date, Time, Date and Time</li>
                </ul>
            </li>
            <li>List Types::
                <ul>
                    <li>Text List, Boolean List, Number List, Date List, Time List, Date and Time List</li>
                </ul>
            </li>
            <li>Structured Data Types:
                <ul>
                    <li>Object, Map, JSON, XML</li>
                </ul>
            </li>
            <li>Media and File Types:
                <ul>
                    <li>Image, URL, File, File List, Audio, Video</li>
                </ul>
            </li>
            <li>Specialized Input Types:
                <ul>
                    <li>Secrets (for tokens, API keys, or sensitive data)</li>
                </ul>
            </li>
        <ul>
        <p>Selecting the appropriate type ensures that Flowcess handles your input accurately, validates it correctly, and offers a seamless experience for both the user and the automation process.</p>

        <h3 class="headingThree underline-text">3. Default Value</h3>
        <p>You can optionally define a Default Value for the input. This is useful when you want to pre-fill a field with a commonly used value, provide a fallback, or make testing easier by supplying sample data. </p>
        `
    },
    "how-to-create-condition-block":{
        title:"Condition Blocks",
        content:`
        <p>Condition Blocks are one of the components in building autonomous AI Agent  in anydone. They enable your AI Agent to make intelligent decisions by evaluating logical rules, comparing data, and triggering different actions based on the results.</p>

        <p>Below are the five core Condition Blocks you can use to build powerful, logic-driven automations:</p>

        <h2 class="headingTwo">Compare Block</h2>
        <p>The Compare Block helps you evaluate conditions by comparing two values: Left-Hand Side (LHS) and Right-Hand Side (RHS). It’s ideal for automating decisions that rely on matching, validating, or calculating values.</p>

        <h3 class="headingThree underline-text">Comparison Options:</h3>
        <p>You can choose from the following conditions:</p>

        <ul>
            <li><strong>Is Equal To – </strong> Triggers if LHS equals RHS.</li>
            <li><strong>Is Not Equal To –</strong> Triggers if LHS does not equal RHS</li>
            <li><strong>Is Less Than – </strong> Triggers if LHS is smaller than RHS.</li>
            <li><strong>Is Less Than or Equal To –</strong> Triggers if LHS is smaller than or equal to RHS.</li>
            <li><strong>Is Greater Than –</strong> Triggers if LHS is larger than RHS.</li>
            <li><strong>Is Greater Than or Equal To – </strong>  Triggers if LHS is larger than or equal to RHS.</li>  
        </ul>
        <p>These comparisons work with numbers, strings, dates, and other types of values.</p>  

        <h3 class="headingThree underline-text">Define Output:</h3>
        <ul>
            <li><strong>If True:</strong> Executes the defined action when the comparison is valid.</li>
            <li><strong>If False:</strong> Executes an alternate action when the condition fails.</li>
        </ul>

        <h3 class="headingThree underline-text">Example Use Case: </h3>
        <p>In our demo, we used the Compare Block to detect when a query isn’t available in the knowledge base. When true, the process triggers a Text Generation model to create an AI generated response in real time.</p>

        <h2 class="headingTwo">Contains Block</h2>
        <p>The Contains Block is used to detect if a specific word, number, or phrase exists within a given input—such as a message, form submission, or user query. It’s perfect for filtering data or triggering actions based on keyword detection.</p>
        <h3 class="headingThree underline-text">How It Works:</h3>
        <ul>
            <li><strong>Define Input Source:</strong> Select the source of the incoming data (e.g., user message or form field).</li>
            <li><strong>Set the Value to Check:</strong> Enter the word or value you want to detect in the input.</li>
        </ul>

        <h3 class="headingThree underline-text">Define Output:</h3>
        <ul>
            <li><strong>If True:</strong> If the value is found, you can trigger notifications, updates, or alerts.</li>
            <li><strong>If False:</strong> If not found, you can define fallback actions, such as requesting clarification or stopping the flow.</li>
        </ul>
        <p><strong>Example Use Case:</strong> <br> If a support request contains the word "urgent", it can immediately escalate the ticket or notify the priority support team.</p>

        <h2 class="headingTwo">Counts Block</h2>
        <p>The Counts Block evaluates the number of items in a dataset—such as records, responses, or objects—and triggers actions based on whether the count meets specific conditions.</p>
        <h3 class="headingThree underline-text">How It Works:</h3>
        <ul>
            <li><strong>Define Input Source:</strong> Choose the data source you want to count items from.</li>
            <li><strong>Set the Condition:</strong> Define the threshold using one of the following:
                <ul>
                    <li>Is Greater Than</li>
                    <li>Is Less Than</li>
                    <li>Is Equal To</li>
                    <li>Is Greater Than or Equal To</li>
                    <li>Is Less Than or Equal To</li>
                </ul>
            </li>
        </ul>
        <p>These options allow you to respond to changes in data volume or behavior dynamically.</p>

        <h3 class="headingThree underline-text">Define Output:</h3>
        <ul>
            <li><strong>If True:</strong> The count meets the condition; trigger the next action.</li>
            <li><strong>If False:</strong> The count doesn’t meet the condition; trigger an alternative path.</li>
        </ul>

        <p><strong>Example Use Case:</strong> <br> We used the Counts Block with Face Detection to demonstrate automated actions when the number of detected faces crosses a defined threshold. You can also use this for monitoring form submissions, order volumes, or survey responses.</p>

        <h2 class="headingTwo">Check Block</h2>
        <p>The Check Block evaluates a single condition and acts as a simple yet powerful decision gate in your workflow.</p>

        <h3 class="headingThree underline-text">How It Works:</h3>
        <ul>
            <li><strong>Define the Condition:</strong> Choose from the following checks:
                <ul>
                    <li>Is Equal To</li>
                    <li>Is Not Equal To</li>
                    <li>Is Greater Than</li>
                    <li>Is Less Than</li>
                    <li>Is Greater Than or Equal To</li>
                    <li>Is Less Than or Equal To</li>
                </ul>
            </li>
        </ul>       
        <p>This is useful for verifying input, validating fields, or controlling the flow based on a single parameter.</p>
        
        <h3 class="headingThree underline-text">Define Output:</h3>
        <ul>
            <li><strong>If True:</strong> Condition is met; move forward with the next action.</li>
            <li><strong>If False:</strong> Condition is not met; reroute or retry the process.</li>
        </ul>
        <p><strong>Example Use Case:</strong> <br> In the demo, we applied the Check Block with Face Detection to determine whether to proceed with an identity match. You can use this in a wide range of decision scenarios—like checking user roles, inventory levels, or verification results.</p>

        <h2 class="headingTwo">Condition Evaluation Block</h2>
        <p>The Condition Evaluation Block allows you to evaluate complex logical expressions using a combination of arithmetic, comparison, and logical operators. This block gives you full flexibility to define conditions in a single line using custom expressions — making it a powerful tool for advanced decision-making in your automation flow.</p>
        
        <h3 class="headingThree underline-text">Expression-Based Evaluation</h3>
        <p>With the Condition Block, instead of comparing fixed values or fields separately, you can input full expressions such as:</p>
        <ul>
            <li>10 > 5 and 3 == 3 or 7 != 8</li>
        </ul>
        <p>The expressions are parsed and evaluated during execution. Based on the result, you can define specific actions for True or False outcomes.</p>

        <h3 class="headingThree underline-text">Supported Operators</h3>
        <p>You can use a wide range of operators to form your conditions:</p>
        <ul>
            <li>Arithmetic Operators: +, -, *, /</li>
            <li>Comparison Operators: ==, !=, >, <, >=, <=</li>
            <li>Logical Operators: AND, OR, NOT (also &&, ||, !)</li>
            <li>Parentheses: () for grouping and precedence control</li>
        </ul>

        <h3 class="headingThree underline-text">Example Conditions</h3>
        <p>You can use a wide range of operators to form your conditions:</p>
        <ul>
            <li>With Operator Names: <br>
            10 greater than 5 and 3 equals 3 or 7 not equals 8
            </li>
            <li>With Operator Symbols: <br>
            10 > 5 AND 3 == 3 OR 7 != 8
            </li>
            <li>With Variables: <br>
             $input1.number1 > $input1.number2 AND $input1.number3 == $input1.number4 OR 7 != 8
            </li>
        </ul>
        <p>This flexibility means you can combine variables, numbers, and logic in a single expression to make your automation both powerful and readable.</p>

        <h3 class="headingThree underline-text">Define Output:</h3>
        <ul>
            <li><strong>If True:</strong> If the condition evaluates to true, the workflow proceeds to the next defined action.</li>
            <li><strong>If False:</strong> If the condition is false, you can trigger an alternative flow, such as logging an error, prompting the user, or retrying an operation.</li>
        </ul>

        <h3 class="headingThree underline-text">When to Use</h3>
        <p>Use the Condition Block when you need:</p>
        <ul>
            <li>To evaluate multiple conditions in a single line.</li>
            <li>To mix variables and static values in your logic.</li>
            <li>To execute complex checks using logical grouping with parentheses.</li>
        </ul>
        <p>This block simplifies advanced logic in Flowcess and ensures that even the most dynamic scenarios are handled precisely.</p>
        `
    },
    "find-in-internet":{
        title:"Find In Internet",
        content:`
        <p>The Find In Internet block allows your AI Agent to perform real-time internet searches, fetch publicly available information, and return the most relevant results in structured or summarized form.</p>

        <p>This block is ideal when your automation flow requires up-to-date or external data that is not stored within your internal systems. Whether it's looking up definitions, news articles, prices, or documentation, this block enables your AI to extend its knowledge beyond what it was trained on.</p>

        <p>This block works well in workflows that rely on dynamic information retrieval, enabling smarter decision-making and contextual conversations.</p>

        <p><strong class="underline-text">Prompt</strong><br>
        This is the instruction or query you want the AI to search on the internet. It can be a static prompt (predefined question) or dynamically pulled from user input or another block’s output.</p>

        <p><strong class="underline-text">Best practice</strong><br>
        Use precise and complete prompts to ensure accurate search results. You can include variables to personalize the search.</p>

        // findin 1
        <video-component src="https://edge-a.anydone.com/treeleaf/488d27ce-14f7-435f-813a-f1c608a07af4.mp4"></video-component>
        // findin 2
        <video-component src="https://edge-a.anydone.com/treeleaf/b88cf034-975b-4c04-98ae-4cd49aefd80c.mp4"></video-component>
        <h2 class="headingTwo">Building a Find In Internet AI Agent in anydone AI Studio</h2>
        <p>The Find In Internet AI Agent in anydone Studio is designed to search the web in real-time and return relevant information based on a user’s query. This is useful for answering general knowledge questions, fetching the latest updates, or providing external context that isn't already available within the agent’s internal knowledge base.</p>

        <p><strong class="underline-text">Input Block</strong><br>
        We begin by using an Input Block where the input type is set to Text. This allows the AI Agent to receive a user-generated query that will be used for performing the internet search. The user can enter a sentence or question in natural language.</p>

        <p><strong class="underline-text">Find In Internet Process Block</strong><br>
        Next, we add the Find In Internet Process block from the Controls section. This block connects with the variable <code>$input_1.prompt</code>, which passes the user’s query to the AI for searching the internet.</p>

        <p><strong class="underline-text">Send Reply Block</strong><br>
        To deliver the web search results back to the user, we use the Send Reply Block. It is connected using the variables <code>$find_in_internet_1.result</code>, which carries the retrieved answer.</p>

        <p>Optionally, the Send Reply Block can also include the variable <code>$find_in_internet_1.citations</code> to show the sources or citations alongside the answer. This adds transparency and credibility to the information provided.</p>

        <p><strong class="underline-text">Log Blocks (Optional)</strong><br>
        We have also added Log blocks after each key action — Input, Internet Search, and Reply. These logs are useful for tracking the flow of operations. They record whether the user input was successfully received, if the internet search completed with or without issues, and whether the final reply was successfully delivered to the user. This helps with debugging and ensures reliable behavior from the AI Agent.</p>
        `
    },
    "web-scrapping":{
        title:"Web Scrapping",
        content:`
        <p>The Web Scraping block enables your AI Agent to extract structured or unstructured information from publicly accessible web pages. This block is ideal when the data you need is embedded in websites but not readily available via APIs or internal sources.</p>

        <p>Whether it's fetching product details, extracting article summaries, or pulling metadata from a URL, this block helps your automation workflows gather web-based data automatically.</p>

        <p>It’s particularly useful in research agents, comparison bots, and content aggregators that rely on extracting information in real time. You can use this block as a standalone step or chain it with summarization, classification, or analytics tasks.</p>

        <p><strong>URL</strong><br>
        This is the target webpage the AI should scrape. The URL can be entered by the user or passed from another block. It should be publicly accessible.</p>

        <p><em>Note:</em> Ensure that the URL structure is valid and points directly to a content-rich page. Avoid redirect URLs and verify that the website allows scraping in its robots.txt.</p>

        <p><strong>Extract Link</strong><br>
        When enabled, this setting allows the block to pull all hyperlinks from the page in addition to the main content. This is useful if you're building a crawler, research assistant, or article linker.</p>
        `
    },
    "how-to-create-confirmation-block":{
        title:"Confirmation Block",
        content:`
        <p>The Confirmation Block is used to explicitly ask users for consent, approval, or verification before proceeding with a particular action in the AI Agent's workflow. It introduces a critical decision point where users can confirm or reject a proposed operation, such as deleting data, submitting a form, scheduling a task, or proceeding with a transaction, and more.</p>

        <p>This block can be useful in scenarios where user intent needs to be double-checked to avoid errors, trigger conditional workflows, or comply with business rules. It helps build trust and gives users control over automated actions.</p>

        <p><strong>Confirmation Text</strong><br>
        Enter a text that will act as a message, shown to the user when the block is triggered. It should clearly communicate what the user is confirming. You can insert static messages or dynamically generate them using variables from earlier blocks.</p>

        <p><strong>Option: YES</strong><br>
        If the user taps or types “Yes,” the flow continues on the “Yes” branch. You can link this response to actions like processing the request, updating a database, or sending a follow-up message.</p>

        <p><strong>Option: NO</strong><br>
        If the user selects “No,” the flow continues on the “No” branch. You can use this path to offer alternative options, provide clarification, or simply exit the conversation.</p>

        <h3 class="headingThree">Note:</h3>
        <ul>
            <li>Use concise and action-oriented language. Make sure the message reflects the specific action being confirmed, e.g., “Do you want to cancel your subscription now?”</li>
            <li>Each response (Yes/No) allows you to build a completely distinct flow—giving full flexibility in decision-making automation.</li>
        </ul>

        <p><strong>Use Case Example</strong><br>
        Cancellation Confirmation Agent <br>
        A user types, “I want to cancel my membership.” <br>
        The AI agent responds with a Confirmation Block asking: <br>
        </p>

        <p>
        “Are you sure you want to cancel your membership effective immediately?” <br>
        If the user clicks Yes, the AI proceeds to cancel the account and send a confirmation message.<br>
        If the user clicks No, the AI offers options such as “Pause membership” or “Talk to an agent.”<br>
        </p>
        `
    },
    "how-to-send-reply":{
        title:"Send Reply",
        content:`
        <p>The Send Reply Block is used to deliver a final response from the AI Agent back to the user or system interface. It serves as the primary output channel of your workflow, ensuring that the processed data — whether it's a text answer, a formatted document, or structured information — reaches the end-user in a usable and readable format.</p>
        <p>In the Send Reply Block, users can configure how the response should be presented. Anydone AI Studio supports multiple output formats to align with diverse use cases:</p>

        <ul>
            <li><strong>Text (Default):</strong> Plain, readable message. Ideal for chat interfaces, notifications, or simple statements.</li>
            <li><strong>HTML:</strong> Structured and stylized content. Useful for rich messages like formatted emails, reports, or chatbot UI with emphasis.</li>
            <li><strong>JSON:</strong> Machine-readable structured data. Ideal for API responses, webhooks, and integrating with external tools.</li>
            <li><strong>XML:</strong> Legacy system compatibility. Suitable for systems that rely on XML parsing and rules.</li>
        </ul>

        `
    },
    "how-to-request-data":{
        title:"Data Request",
        content:`
        <p>The Data Request Type block defines the method your AI Agent will use to collect data. This block ensures that data is gathered efficiently and in the format best suited for your workflow, providing flexibility for various use cases.</p>

        <p><strong>Data Request Type:</strong><br>
        Select between Form or Live Capture.</p>

        <p><strong>Specific Selection:</strong><br>
        Depending on the selected type, you can further specify the Form or Live Capture integration.</p>

        <p><strong>Message:</strong><br>
        Once the type and specific details are chosen, the Message placeholder enables the entry of a custom message, which will accompany the selected data request. This can include dynamic placeholders or text for personalized interactions.</p>
        `
    },
    "how-to-create-authenticate-block":{
        title:"Authenticate Block",
        content:`
        <p>The Authentication Block is used in anydone’s AIChat to ensure secure access before users can interact with the system. Once this block is triggered in the flow, users are required to authenticate by providing their name and email address.</p>
        <p>After submission, anydone sends an OTP code to the specified email. The user must then copy and paste the OTP to complete the authentication process. Once successfully authenticated, the email is confirmed, and the user can continue with AIChat.</p>
        `
    },
    "how-to-create-forward-block":{
        title:"Forward Block",
        content:`
        <p>The Forward Block allows you to define where to send the output. This block gives you control over the destination of the generated data, ensuring that it reaches the appropriate system, application, or recipient. Whether you're forwarding information to a specific within your anydone workspace, an API, or an email, the Forward Block streamlines the process by automating the redirection of output to your desired location.</p>

        <p><strong>Anydone</strong><br>
        Select an anydone app that you’ve created in the App Integration section. This option allows you to forward the output directly to a designated CoSpace within anydone’s platform, ensuring seamless integration with your existing workflows.</p>

        <p><strong>API</strong><br>
        Choose the API created in the process. By selecting this option, you can send the output to any API you’ve set up, enabling your systems to interact with external platforms or trigger further actions based on the forwarded data.</p>

        <p><strong>Email</strong><br>
        Select the email integration you’ve set up. Under the "To" field, define where you want to forward the email. You can also set the subject and message of the email, ensuring the content is forwarded in a personalized and structured way.</p>
        `
    },
    "how-to-create-template-block":{
        title:"Template Block",
        content:`
        <p>The Template Block allows you to define the format in which data will be generated and presented. This block ensures that the output is structured according to your preferred format, making it easier to integrate into various systems, applications, or communication channels. Whether you're sending information through a message, API, or email, the Template Block ensures the content is delivered in the right structure.</p>

        <p><strong>Text</strong><br>
        Choose the Text option for simple, unformatted content. This format is ideal when you need to send plain text, such as brief messages or basic data, without any additional styling or structure.</p>

        <p><strong>HTML</strong><br>
        The HTML option allows you to send content with rich formatting, including text styles (bold, italic), hyperlinks, and more. This is perfect for creating visually appealing messages or emails that require structured content with specific design elements.</p>

        <p><strong>JSON</strong><br>
        Select JSON when you need to send data in a structured, machine-readable format. This option is ideal for APIs, integrations, or data transfer where the content needs to be parsed and processed programmatically by other systems or applications.</p>

        <p><strong>XML</strong><br>
        Choose XML when you need a structured format that is both human-readable and machine-friendly. This option is commonly used for data exchange between different systems, making it easy to maintain hierarchical relationships within the data.</p>

        <video-component></video-component>
        `
    }
  };
  